var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.$route.meta.fullpage)?_c('AppBar'):_vm._e(),(!_vm.$route.meta.fullpage)?_c('Drawer'):_vm._e(),_c('v-main',{class:this.$route.meta.class},[_c('div',{class:!_vm.$route.meta.fullpage
          ? _vm.$vuetify.breakpoint.mdAndDown
            ? 'py-8'
            : 'px-8 py-8'
          : 'fill-height'},[(!_vm.$route.meta.fullpage)?_c('Breadcrumb'):_vm._e(),_c('router-view')],1)]),_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"500"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }